export const GET_DASHBOARD_WITHOUT_SESSION = 'GET_DASHBOARD_WITHOUT_SESSION';
export const SET_DASHBOARD_WITHOUT_SESSION = 'SET_DASHBOARD_WITHOUT_SESSION';

export const GET_DASHBOARD_WITH_SESSION = 'GET_DASHBOARD_WITH_SESSION';
export const SET_DASHBOARD_WITH_SESSION = 'SET_DASHBOARD_WITH_SESSION';

export const GET_DASHBOARD_WITH_SESSION_SHIBBOLETH = 'GET_DASHBOARD_WITH_SESSION_SHIBBOLETH';
export const SET_DASHBOARD_WITH_SESSION_SHIBBOLETH = 'SET_DASHBOARD_WITH_SESSION_SHIBBOLETH';

export const GET_DASHBOARD_WITH_SESSION_ACCOUNT_IDENTIFIER = 'GET_DASHBOARD_WITH_SESSION_ACCOUNT_IDENTIFIER';
export const SET_DASHBOARD_WITH_SESSION_ACCOUNT_IDENTIFIER = 'SET_DASHBOARD_WITH_SESSION_ACCOUNT_IDENTIFIER';

export const GET_DASHBOARD_EMAIL_VERIFICATION = 'GET_DASHBOARD_EMAIL_VERIFICATION';
export const SET_DASHBOARD_EMAIL_VERIFICATION = 'SET_DASHBOARD_EMAIL_VERIFICATION';


export const getDashboardHtmlWithoutSession = (payload) => {
    return {
        type: GET_DASHBOARD_WITHOUT_SESSION,
        payload
    }
}
export const setDashboardHtmlWithoutSession = (payload) => {
    return {
        type: SET_DASHBOARD_WITHOUT_SESSION,
        payload
    }
}

export const getDashboardHtmlWithSession = (payload) => {
    return {
        type: GET_DASHBOARD_WITH_SESSION,
        payload
    }
}
export const setDashboardHtmlWithSession = (payload) => {
    return {
        type: SET_DASHBOARD_WITH_SESSION,
        payload
    }
}

export const getDashboardHtmlWithSessionShibboleth = (payload) => {
    return {
        type: GET_DASHBOARD_WITH_SESSION_SHIBBOLETH,
        payload
    }
}
export const setDashboardHtmlWithSessionShibboleth = (payload) => {
    return {
        type: SET_DASHBOARD_WITH_SESSION_SHIBBOLETH,
        payload
    }
}


// Get Account Identifier ID


export const getDashboardHtmlWithSessionAccountIdentifier = (payload) => {
    return {
        type: GET_DASHBOARD_WITH_SESSION_ACCOUNT_IDENTIFIER,
        payload
    }
}
export const setDashboardHtmlWithSessionAccountIdentifier = (payload) => {
    return {
        type: SET_DASHBOARD_WITH_SESSION_ACCOUNT_IDENTIFIER,
        payload
    }
}

// Email Verification

export const getDashboardEmailVerification = (payload) => {
    return {
        type: GET_DASHBOARD_EMAIL_VERIFICATION,
        payload
    }
}
export const setDashboardEmailVerification = (payload) => {
    return {
        type: SET_DASHBOARD_EMAIL_VERIFICATION,
        payload
    }
}